import { useState, useEffect, useRef } from "react";
import { ArticleExtraData } from "../../../../../../../articlePage/stateInterfaces";
import { minutesDiff } from "./newsFlashSpecialDesktopComponent";
import { isWcmEditor } from "../../../../../../../config/serverConfig";
import { DateDisplay } from "../../../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { getTranslation } from "../../../../autoTickerRowWidget/autoTickerRowTranslations";
import { getFrontImageUrl } from "../../../../../../../front/staticServerRendering/frontImage";

interface NewsFlashSpecialDesktopSlotItemProps {
    article: ArticleExtraData
    languageCode: string
    index?: number
    isLTR?: boolean
    nowDuration?: number
    isFlashPage?: boolean
    isInitialLoad?: boolean
    isNewlyArrived?: boolean
    isFirstInterval?: boolean
    bgHighlightDuration?: number
    onRowItemToggle?: (articleId: string) => void
}

const mediaAspectRatios = {
    "6:7": { w: 215, h: 251 },
    "16:9": { w: 448, h: 251 },
    "9:16": { w: 207, h: 370 },
}

export const NewsFlashSpecialDesktopSlotItem = (props: NewsFlashSpecialDesktopSlotItemProps) => {

    const { index, isLTR, article, languageCode, bgHighlightDuration, isFirstInterval, isFlashPage, isNewlyArrived, isInitialLoad, nowDuration, onRowItemToggle } = props;
    const [shouldDisplayArticle, setShouldDisplayArticle] = useState(true);
    const isFirstRenderRef: any = useRef(true);

    const { articleId, roof, title, dateUpdatedOnSite, specialData, video } = article;
    const { mediaLinkType, mediaProportion } = specialData;
    const isRecentItem = nowDuration != null && minutesDiff(article) < (nowDuration || 1);
    const wasRecentOnMount: any = useRef(isInitialLoad && isRecentItem);
    const shouldHighlight = isNewlyArrived || wasRecentOnMount.current;
    const lang = languageCode ? languageCode.slice(0, 2) : "he";
    const date = isRecentItem ? getTranslation(lang, "Now") : <DateDisplay date={dateUpdatedOnSite} isMinutesAgo={true} isArticle={true} />;
    const mediaId = !isWcmEditor() && mediaLinkType === "video" && video && video[0] && video[0].mediaVideoId ? video[0].mediaVideoId : "";
    const animationStyle = shouldHighlight && bgHighlightDuration !== 0 ? { animationDuration: `${bgHighlightDuration}s` } as React.CSSProperties : undefined;

    const getPosterUrl = () => {
        const { promotionImageDetails, video } = article;
        const mediaPosterSize = mediaLinkType !== "none" && mediaLinkType !== undefined && mediaProportion ? mediaAspectRatios[mediaProportion] : { w: 448, h: 251 };

        if (mediaLinkType !== "none" && mediaLinkType !== undefined) {
            if (mediaLinkType === "image") {
                return getFrontImageUrl(promotionImageDetails, mediaPosterSize);
            } else if (mediaLinkType === "video" && video && video[0]) {
                return video[0].posterSrc;
            }
        }
    };

    const onSlotClickHandler = (e: React.MouseEvent) => {
        if (onRowItemToggle) {
            onRowItemToggle(articleId);
        }
    };

    useEffect(() => {
        if (!isFlashPage && isFirstRenderRef.current) {
            isFirstRenderRef.current = false;

            if (isInitialLoad) return;

            const isNow = minutesDiff(article) === 0;
            const isUpToFiveMin = nowDuration && minutesDiff(article) < nowDuration;

            if (isFirstInterval) {
                if (isUpToFiveMin) setShouldDisplayArticle(false);
            } else {
                if (isNow) setShouldDisplayArticle(false);
            }

            setTimeout(() => {
                setShouldDisplayArticle(true);
            }, 3000);
        }
    }, []);

    if (!shouldDisplayArticle) return null;

    return (
        <div className={`newsflash-special-desktop-item ${shouldHighlight ? "highlight-new" : ""}`} style={animationStyle} data_analytics_id={articleId}>
            <div className="slotInfo" onClick={onSlotClickHandler}>
                {mediaLinkType !== "none" && mediaLinkType !== undefined &&
                    <div className="image-container" data_mediaid_analitycs={mediaId}>
                        <img className="posterImage" src={getPosterUrl()} alt={title} />

                        {mediaLinkType === "video" && <div className="video-icon"></div>}

                        {mediaLinkType === "image" && <div className="expand-image-icon"></div>}
                    </div>
                }

                <div className="slotInfoText">
                    {roof && <span className="roofTitle">{roof}</span>}

                    <div className="slotTitle">{title}</div>

                    <div className="dateView">{date}</div>
                </div>
            </div>
        </div>
    );
};